/**
 * Generates an avatar URL using the ui-avatars.com API
 * Uses tertiary color (lavanda) for user avatars
 * @param {string} firstName - User's first name
 * @param {string} lastName - User's last name
 * @returns {string} Avatar URL
 */
export const generateAvatarUrl = (firstName = 'User', lastName = '') => {
  const name = `${firstName} ${lastName}`.trim();
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=c2b4e4&color=fff`;
};
